import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { notification, FRONTEND_BASE_URL } from "../../../../utils/utility";
import { getAdminBusinessId } from "../../../../utils/authHelper";
import { renderToStaticMarkup } from "react-dom/server";
import moment from "moment";

/* ─── Design tokens ──────────────────────────────────────────────────────── */
const C = {
  navy:      "#0c4767",
  navyLight: "#e8f1f7",
  orange:    "#FE9920",
  dark:      "#111827",
  mid:       "#374151",
  muted:     "#6B7280",
  faint:     "#9CA3AF",
  border:    "#E5E7EB",
  surface:   "#F9FAFB",
  white:     "#ffffff",
  green:     "#10B981",
};

const STYLES = `
  .ate-slot-btn {
    background: #fff;
    color: #0c4767;
    border: 2px solid #E5E7EB;
    border-radius: 8px;
    padding: 9px 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: default;
    font-family: 'Courier New', monospace;
    letter-spacing: 0.5px;
    text-align: center;
    width: 100%;
  }
`;

class AddTimeToEmailDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, copied: false };
  }

  toggle = () => this.setState(prev => ({ isOpen: !prev.isOpen }));

  onCopyCode = () => {
    const { slots, event } = this.props;
    const { event_url } = event;
    // Build the "Change timezone" URL.
    // /booking/:business_id/:slug loads the full calendar + timezone-selector page.
    // business_id is read from localStorage (set on login) and is always present
    // while the admin is composing this email. Falls back to "b" as a safe placeholder
    // (the Booking component only uses :slug to fetch the event; :business_id is ignored).
    const businessId = getAdminBusinessId() || "b";
    const changeTimezoneUrl = `${FRONTEND_BASE_URL}booking/${businessId}/${event_url}`;

    const content = (
      <table width="344" style={{ width: "344px", maxWidth: "344px", fontFamily: "Sofia Pro, sans-serif", fontStyle: "normal", fontWeight: "normal", fontSize: "16px", backgroundColor: "white" }}>
        <tbody>
          <tr>
            <td>
              <div style={{ paddingBottom: "3px", fontFamily: "Sofia Pro, sans-serif", fontSize: "13px", color: C.navy, backgroundColor: "white", lineHeight: 1.4, width: "344px" }}>
                <div style={{ fontFamily: "Sofia Pro, sans-serif", fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "19px", color: C.navy, marginTop: "15px" }}>
                  {event.event_title}
                </div>
                <div style={{ fontFamily: "Sofia Pro, sans-serif", fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "17px", color: C.orange }}>
                  {event.timeslot} mins
                </div>
                <div>
                  {/* /booking/:business_id/:slug — full calendar + timezone-selector page */}
                  <a href={changeTimezoneUrl} style={{ marginLeft: 3, color: C.navy }}>Change timezone</a>
                </div>
                {Object.keys(slots).map((key, index) => (
                  <table key={`dated-${index}`} style={{ marginTop: "16px", textAlign: "left", borderCollapse: "collapse", borderSpacing: 0, width: "362px" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", marginTop: "16px" }}>
                          <span style={{ fontFamily: "Sofia Pro, sans-serif", fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "16px", color: C.navy, paddingBottom: 8 }}>
                            {moment(key, "YYYY-MM-DD").format("dddd, MMMM, DD YYYY")}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ borderCollapse: "separate", borderSpacing: "0px 4px" }}>
                            <tbody>
                              <tr style={{ height: "25px" }}>
                                {(slots[key] || []).map((slot, innerIndex) => (
                                  <td key={innerIndex} style={{ padding: 0, width: 64, display: "inline-block", marginRight: 4, height: 22, float: "left", border: `1px solid ${C.orange}`, borderRadius: 3 }}>
                                    <table style={{ height: 21 }}>
                                      <tbody>
                                        <tr style={{ height: 21 }}>
                                          <td style={{ width: 7 }}></td>
                                          <td style={{ width: 50, textAlign: "center" }}>
                                            <a href={`${FRONTEND_BASE_URL}booking/${event_url}/${key}/${slot}`} className="spot" style={{ fontFamily: "Sofia Pro, sans-serif", textDecoration: "none", textAlign: "center", color: C.orange, fontSize: 12, lineHeight: 1.6 }}>
                                              <b style={{ fontWeight: "normal", textDecoration: "none" }}>{slot}</b>
                                            </a>
                                          </td>
                                          <td style={{ height: 7 }}></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );

    document.getElementById("ate-copy-element").innerHTML = renderToStaticMarkup(content);
    const str = document.getElementById("ate-copy-element").innerHTML;

    const copyHandler = (e) => {
      e.clipboardData.setData("text/html", str);
      e.clipboardData.setData("text/plain", str);
      e.preventDefault();
    };
    document.addEventListener("copy", copyHandler);
    document.execCommand("copy");
    document.removeEventListener("copy", copyHandler);

    this.setState({ copied: true });
    setTimeout(() => this.setState({ copied: false }), 2500);
    notification.success("Slots copied — paste into your email!");
  };

  render() {
    const { isOpen, copied } = this.state;
    const { event, slots } = this.props;
    const { event_title } = event;

    const totalSlots = Object.values(slots).flat().length;
    const totalDays  = Object.keys(slots).filter(k => (slots[k] || []).length > 0).length;

    return (
      <>
        <button
          type="button"
          onClick={this.toggle}
          style={{
            background: C.orange, color: C.white, border: "none",
            borderRadius: "8px", padding: "9px 20px",
            fontSize: "13px", fontWeight: 700, cursor: "pointer",
          }}
        >
          Continue
        </button>

        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className="event-modal modal-lg modal-dialog"
          contentClassName="ate-modal-content"
        >
          <ModalBody style={{ padding: 0 }}>
            <style>{STYLES}</style>
            {/* Hidden copy buffer */}
            <div id="ate-copy-element" style={{ display: "none" }} />

            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

              {/* ── Event header ────────────────────────────────── */}
              <div style={{
                padding: "20px 24px 16px",
                borderBottom: `1px solid ${C.border}`,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "12px",
              }}>
                <div>
                  <h3 style={{ margin: "0 0 4px", fontSize: "16px", fontWeight: 700, color: C.dark }}>
                    {event_title}
                  </h3>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                    <span style={{ fontSize: "13px", color: C.muted, display: "flex", alignItems: "center", gap: "4px" }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={C.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                      </svg>
                      {event.timeslot !== "Customized" ? `${event.timeslot} mins` : event.timeslot}
                    </span>
                    {event.venue && (
                      <span style={{ fontSize: "13px", color: C.muted }}>· {event.venue}</span>
                    )}
                    <span style={{ fontSize: "13px", color: C.muted }}>
                      · {event.event_format_id === 1 ? "One to One" : "Group"}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={this.toggle}
                  aria-label="Close"
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: C.faint, padding: "4px", borderRadius: "6px", flexShrink: 0,
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>

              {/* ── Event name row with Change ───────────────────── */}
              <div style={{
                padding: "12px 24px",
                borderBottom: `1px solid ${C.border}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: C.surface,
              }}>
                <div>
                  <p style={{ margin: "0 0 2px", fontSize: "11px", fontWeight: 700, color: C.faint, textTransform: "uppercase", letterSpacing: "0.7px" }}>
                    Event
                  </p>
                  <p style={{ margin: 0, fontSize: "14px", fontWeight: 600, color: C.dark }}>{event_title}</p>
                </div>
                <button
                  type="button"
                  onClick={this.toggle}
                  style={{
                    background: "none", border: `1px solid ${C.border}`, cursor: "pointer",
                    color: C.navy, borderRadius: "7px", padding: "5px 14px",
                    fontSize: "12px", fontWeight: 600,
                  }}
                >
                  Change
                </button>
              </div>

              {/* ── Slots section ────────────────────────────────── */}
              <div style={{ flex: 1, overflowY: "auto", maxHeight: "400px" }}>

                {/* Section header — matches adhoc "Times you're offering" */}
                <div style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "14px 24px", borderBottom: `1px solid ${C.border}`,
                }}>
                  <span style={{ fontSize: "14px", fontWeight: 700, color: C.dark }}>
                    Times you're sharing
                  </span>
                  {totalSlots > 0 && (
                    <span style={{
                      display: "inline-flex", alignItems: "center", justifyContent: "center",
                      width: 22, height: 22, borderRadius: "50%",
                      background: C.navy, color: "#fff",
                      fontSize: "11px", fontWeight: 700, flexShrink: 0,
                    }}>
                      {totalSlots}
                    </span>
                  )}
                </div>

                {totalSlots === 0 ? (
                  <div style={{
                    display: "flex", flexDirection: "column", alignItems: "center",
                    justifyContent: "center", padding: "40px 20px", textAlign: "center",
                  }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={C.faint} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 10 }}>
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: "13px", color: C.muted }}>No times selected. Go back and pick time slots.</p>
                  </div>
                ) : (
                  /* Day rows — each row: compact date label | inline slot tags */
                  Object.keys(slots).map((key, index) => {
                    const daySlots = slots[key] || [];
                    if (!daySlots.length) return null;
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex", alignItems: "center", flexWrap: "wrap",
                          gap: "8px", padding: "12px 24px",
                          borderBottom: `1px solid ${C.border}`,
                        }}
                      >
                        {/* Compact date label */}
                        <span style={{
                          fontSize: "13px", fontWeight: 700, color: C.navy,
                          minWidth: "80px", flexShrink: 0,
                        }}>
                          {moment(key, "YYYY-MM-DD").format("ddd D MMM")}
                        </span>

                        {/* Inline slot pills */}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                          {daySlots.map((slot, innerIndex) => (
                            <span
                              key={innerIndex}
                              style={{
                                display: "inline-flex", alignItems: "center",
                                background: C.navyLight, color: C.navy,
                                borderRadius: "999px", padding: "5px 12px",
                                fontSize: "13px", fontWeight: 600,
                                fontFamily: "'Courier New', monospace",
                                letterSpacing: "0.3px",
                              }}
                            >
                              {slot}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* ── Footer — matches adhoc "Times you're offering" footer ── */}
              <div style={{
                padding: "14px 24px",
                borderTop: `1px solid ${C.border}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                background: C.surface,
              }}>
                {/* Count summary — left side */}
                <span style={{ fontSize: "13px", color: C.muted }}>
                  {totalSlots > 0
                    ? `${totalSlots} time${totalSlots !== 1 ? "s" : ""} selected · ${event.timeslot !== "Customized" ? `${event.timeslot} mins each` : "Customized"}`
                    : "No times selected"}
                </span>

                {/* Actions — right side */}
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <button
                    type="button"
                    onClick={this.toggle}
                    style={{
                      display: "flex", alignItems: "center", gap: "5px",
                      background: "none", border: "none", cursor: "pointer",
                      fontSize: "13px", color: C.muted, padding: "4px 0",
                    }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 18 9 12 15 6"/>
                    </svg>
                    Back
                  </button>

                  <button
                    type="button"
                    onClick={this.onCopyCode}
                    disabled={totalSlots === 0}
                    style={{
                      background: totalSlots === 0 ? "#E5E7EB" : C.navy,
                      color: totalSlots === 0 ? C.faint : C.white,
                      border: "none", borderRadius: "8px",
                      padding: "9px 22px", fontSize: "13px", fontWeight: 700,
                      cursor: totalSlots === 0 ? "not-allowed" : "pointer",
                      display: "flex", alignItems: "center", gap: "7px",
                      transition: "background 0.15s",
                    }}
                  >
                    {copied ? (
                      <>
                        <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                        </svg>
                        Copied!
                      </>
                    ) : (
                      <>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                        </svg>
                        Copy to Email
                      </>
                    )}
                  </button>
                </div>
              </div>

            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default AddTimeToEmailDetailModal;
